<template>
  <div
    class="mx-auto flex h-full max-w-96 flex-col items-center justify-center gap-y-4 text-center lg:mt-8 lg:gap-y-8 xl:max-w-2xl"
  >
    <h1 v-if="title" class="title text-center">{{ title }}</h1>
    <h2 v-if="subtitle" class="subtitle text-center">{{ subtitle }}</h2>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string;
  subtitle?: string;
}

defineProps<Props>();
</script>
